import {createReducer} from '@reduxjs/toolkit'
import {changeEventAction, getEvent, getMembers} from '../actions/event'
import {EventState} from '../types/state'

const defaultState: EventState = {
  event: null,
}

export const event = createReducer(defaultState, builder => {
  builder
    .addCase(changeEventAction, (state, action) => {
      state.event = action.payload.event
    })
    .addCase(getEvent.fulfilled, (state, action) => {
      state.event = action.payload
    })
    .addCase(getMembers.fulfilled, (state, action) => {
      if (action.payload) {
        state.event.members = action.payload.members
        state.event.totalGuests = action.payload.totalGuests
      }
    })
})
